import { render } from 'preact';
import { App } from './App.js';
import '@fontsource-variable/plus-jakarta-sans/wght.css';
import './styles.css';

render(<App />, document.getElementById('app')!);
